import React, { useEffect, useState } from "react";
import "./Candidatestatus.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  InputAdornment,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { ReactComponent as Searchicon } from "./assets/searchicon.svg";
import { ReactComponent as InfoNoReferIcon } from "./assets/info-norefer.svg";
import axiosInstance from "./utils/axios";
import { text } from "stream/consumers";

export default function CandidateStatus(props: any) {
  const [cspage, setCsPage] = React.useState(0);
  const [csrowsperpage, setCsRowsPerPage] = React.useState(10);
  const [csrows, setCsRows] = React.useState([]);
  const [csloading, setCsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const getCandidateStatusList = async () => {
      setCsLoading(true);
      axiosInstance
        .get(`/candidatelist/?referrer_email=${props.email}`)
        .then((response: any) => {
          setCsRows(response.data);
          getCandidateStatusCount(response.data);
          setCsLoading(false);
        })
        .catch((error) => {
          console.log(error.response.data.error);
          setCsLoading(false);
        });
    };
    getCandidateStatusList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCandidateStatusCount = (data: any) => {
    const candidateCountMap: any = {};
    data.forEach((item: any) => {
    const { status } = item;
    candidateCountMap[status] = (candidateCountMap[status] || 0) + 1;
    });
    // console.log(data.length);
    const totalstatuscount = data.length > 0 ? data.length : 0;
    props.onStatusCount(candidateCountMap, totalstatuscount);
};

  const handleChangePage = (event: any, newPage: any) => {
    setCsPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setCsRowsPerPage(parseInt(event.target.value, 10));
    setCsPage(0);
  };

  const cshandleSearch = (event: any) => {
    setSearchTerm(event.target.value);
    setCsPage(0);
  };

  const filteredData = csrows.filter((row: any) =>
    ['name', 'email', 'status'].some(
        (column) =>
        row[column].toLowerCase().includes(searchTerm.toLowerCase())
    )
    // row.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  return (
    <div>
      <div style={{color:"#d32f2f",paddingLeft:"3%", paddingBottom:"10px", textAlign:"center",position:"relative", bottom:"24px",fontWeight:"600"}}>
        *** Referral candidate status is available only for a period of six months ***
      </div>
    { (csrows.length === 0 && !csloading) ? 
     <div className="noreferal-section">
      <div className="noreferal-icon"><InfoNoReferIcon/></div>
        <div className="noreferal-content">
          No Referral Details Found
         </div>
     </div>
    :
    <div>
      <TextField
        style={{ width: "35%" ,paddingLeft:"3%", paddingBottom:"18px" }}
        placeholder="Search by Name or Email or Status..."
        sx={{
          ".css-1o9s3wi-MuiInputBase-input-MuiOutlinedInput-input": {
            padding: "8px 0px",
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Searchicon />
            </InputAdornment>
          ),
        }}
        onChange={cshandleSearch}
      />
      {csloading && (
        <div className="loading-section">
          <div>
            <CircularProgress size="3.5rem" />
          </div>
          <div>Loading Please wait...</div>
        </div>
      )}
      {!csloading && (
        <div className="">
          <TableContainer
            style={{
              width: "95%",
              margin: "0 auto",
            }}
          >
            <Table aria-label="collapsible table">
              <TableHead
                sx={{
                  borderBottom: "2px solid #bfbfbf",
                }}
              >
                <TableRow>
                  <TableCell className="table-head">Name</TableCell>
                  <TableCell className="table-head">Email</TableCell>
                  <TableCell className="table-head">Skills</TableCell>
                  <TableCell className="table-head">Position ID</TableCell>
                  <TableCell className="table-head">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="candidatestatus-table">
                {filteredData
                  .slice(
                    cspage * csrowsperpage,
                    cspage * csrowsperpage + csrowsperpage
                  )
                  .map((row: any, index: any) => (
                    <TableRow
                      key={index}
                      style={
                        index % 2
                          ? {
                              background: "#fff",
                            }
                          : {
                              background: "rgba(73,134,194,0.11)",
                            }
                      }
                    >
                      <TableCell
                        className="table-cell"
                        style={{
                          width: "15%",
                          cursor: "pointer",
                        }}
                      >
                        {row.name}
                      </TableCell>
                      <TableCell
                        className="table-cell"
                        style={{
                          width: "15%",
                        }}
                      >
                        {row.email}
                      </TableCell>
                      <TableCell
                        className="table-cell"
                        style={{
                          width: "22%",
                        }}
                      >
                        {row.skills}
                      </TableCell>
                      <TableCell
                        className="table-cell"
                        style={{
                          width: "10%",
                        }}
                      >
                        {row.referrer_positionid}
                      </TableCell>
                      <TableCell
                        className="table-cell"
                        style={{
                          width: "15%",
                          textTransform: "capitalize",
                        }}
                      >
                        <b>{row.status}</b>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={filteredData.length}
              rowsPerPage={csrowsperpage}
              page={cspage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                marginTop: "0.75em",
                color: "#1D68B3",
                "& .MuiIconButton-root.Mui-disabled": {
                  color: "rgba(29,104,179,0.60)",
                },
                "& .MuiIconButton-root": {
                  color: "#1D68B3",
                },
                "& .MuiTablePagination-select , & .MuiTablePagination-select:focus":
                  {
                    // border: "1px solid #1D68B3",
                    // borderRadius: "5px",
                    background: "transparent",
                    fontWeight: "600",
                  },
                ".MuiTablePagination-displayedRows": {
                  fontSize: "16px",
                  fontWeight: "400",
                },
                ".MuiTablePagination-selectLabel": {
                  fontSize: "16px",
                  fontWeight: "400",
                },
                ".MuiMenuItem-gutters": {
                  background: "red",
                },
              }}
            />
          </TableContainer>
        </div>
      )}
    </div>
    }
    </div>
  );
}
